/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElForm as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElSelect as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import __unplugin_components_4 from '~icons/ep/plus';
import __unplugin_components_3 from '~icons/ep/minus';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-521c809b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex flex-col"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { apiGetAllPayType, apiAddPayRule, apiUpdatePayRule, apiGetRuleDetail, apiTestRule } from '@/api/miniApp';
export default /*#__PURE__*/_defineComponent({
  __name: 'payRule',
  props: {
    gid: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['success'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const form = ref({
      id: 0,
      name: '',
      expressions: [{
        exp: ''
      }],
      val_ids: []
    });
    const dialogFormVisible = ref(false);
    const testForm = ref({
      exp: '',
      exp_params: ''
    });
    watch(() => props.data, val => {
      // console.log(val);
      if (val && val.id) {
        apiGetRuleDetail({
          id: val.id
        }).then(res => {
          if (res.code === 0) {
            form.value = res.data;
          }
        });
      }
    }, {
      immediate: true
    });
    const handleClick = (type, index) => {
      if (type === 'save') {
        const api = form.value.id ? apiUpdatePayRule : apiAddPayRule;
        api({
          game_id: props.gid,
          ...form.value
        }).then(res => {
          if (res.code === 0) {
            emits('success');
          }
        });
      } else if (type === 'add') {
        form.value.expressions.push({
          exp: ''
        });
      } else if (type === 'test') {
        const exp = form.value.expressions[index].exp;
        testForm.value.exp = exp;
        if (exp) {
          dialogFormVisible.value = true;
        }
      } else {
        form.value.expressions.splice(index, 1);
      }
    };
    const handleTest = () => {
      // console.log(testForm.value);
      apiTestRule({
        exp: testForm.value.exp,
        // exp_params: JSON.stringify(JSON.parse(testForm.value.exp_params))
        exp_params: testForm.value.exp_params
      }).then(res => {
        if (res.code === 0) {
          if (res.data.is_match) {
            ElMessage.success('匹配成功');
          } else {
            ElMessage.error('匹配失败');
          }
        }
      });
    };
    const handleTestCancel = () => {
      dialogFormVisible.value = false;
      testForm.value = {
        exp: '',
        exp_params: ''
      };
    };
    const payMethods = ref([]);
    const getPayMethods = () => {
      apiGetAllPayType({
        game_id: props.gid
      }).then(res => {
        if (res.code === 0) {
          payMethods.value = res.data;
        }
      });
    };
    onMounted(() => {
      getPayMethods();
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_i_ep_minus = __unplugin_components_3;
      const _component_i_ep_plus = __unplugin_components_4;
      const _component_el_option = __unplugin_components_5;
      const _component_el_select = __unplugin_components_6;
      const _component_el_form = __unplugin_components_7;
      const _component_el_dialog = __unplugin_components_8;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [(_openBlock(), _createBlock(_Teleport, {
        to: "#payRule"
      }, [_createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = $event => handleClick('save')),
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode("保存")]),
        _: 1
      })])), _createVNode(_component_el_form, {
        "label-position": "top"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "策略名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).name = $event),
            class: "width300px",
            placeholder: "请输入策略名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "自定义筛选条件"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).expressions, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "rule"
            }, [_createVNode(_component_el_input, {
              modelValue: item.exp,
              "onUpdate:modelValue": $event => item.exp = $event,
              class: "width300px",
              placeholder: "请输入表达式"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_button, {
              onClick: $event => handleClick('test', index),
              type: "primary",
              link: ""
            }, {
              default: _withCtx(() => [_createTextVNode("测试")]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              onClick: $event => handleClick('minus', index),
              class: "marginL10",
              type: "danger",
              size: "small",
              circle: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_minus)]),
              _: 2
            }, 1032, ["onClick"])]);
          }), 128))]), _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = $event => handleClick('add')),
            style: {
              "width": "32px"
            },
            class: "marginL10",
            type: "primary",
            circle: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_i_ep_plus)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "支付方式"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(form).val_ids,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).val_ids = $event),
            multiple: "",
            placeholder: "请选择支付方式"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(payMethods), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogFormVisible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(dialogFormVisible) ? dialogFormVisible.value = $event : null),
        title: "测试表达式",
        onClose: handleTestCancel
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: handleTestCancel
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleTest
        }, {
          default: _withCtx(() => [_createTextVNode("测试")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, null, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "表达式"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(testForm).exp), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "参数值"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(testForm).exp_params,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(testForm).exp_params = $event),
              class: "width300px",
              placeholder: "请输入参数值"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});